<template>
  <footer :class="classModifiers" @click="handleSecretTap">
    <transition
      name="footer-expand"
      @enter="onFooterExpandEnter"
      @after-enter="onFooterExpandStopFrame"
      @enter-cancelled="onFooterExpandStopFrame"
    >
      <div class="footer__top" v-if="isLayoutMobile || expanded">
        <div class="footer__top-content">
          <div class="row row-y footer__row">
            <div class="column small-12 medium-12 large-4">
              <router-link :to="{ name: 'home' }" custom v-slot="{ navigate }">
                <div class="footer__logo" @click="navigate"></div>
              </router-link>
            </div>
            <div class="column small-12 medium-12 large-8">
              <div class="row">
                <div class="column small-12 medium-4">
                  <div :class="sectionClassModifiers('engage')" @click="toggleSection('engage')">
                    Engage
                  </div>
                  <div class="footer__section-divider"></div>
                  <template v-if="isSectionVisible('engage')">
                    <router-link :to="{ name: 'market-list' }" class="footer__link">
                      Markets
                    </router-link>
                    <a href="#" class="footer__link" @click.stop.prevent="toggleSearchBar"
                      >Search</a
                    >
                    <router-link
                      v-if="leaderboardsEnabled"
                      :to="{ name: 'leaderboards' }"
                      class="footer__link"
                    >
                      Leaderboards
                    </router-link>
                    <router-link :to="{ name: 'news-stories' }" class="footer__link">
                      News
                    </router-link>
                    <router-link :to="{ name: 'learn-stories' }" class="footer__link">
                      Learn
                    </router-link>
                  </template>
                </div>
                <div class="column small-12 medium-4">
                  <div :class="sectionClassModifiers('learn')" @click="toggleSection('learn')">
                    Support
                  </div>
                  <div class="footer__section-divider"></div>
                  <template v-if="isSectionVisible('learn')">
                    <router-link :to="{ name: 'WhatIsPredictIt' }" class="footer__link">
                      About
                    </router-link>
                    <router-link :to="{ name: 'sitemap' }" class="footer__link">
                      Site Map
                    </router-link>
                    <router-link :to="{ name: 'HelpAndSupport' }" class="footer__link">
                      Support
                    </router-link>
                    <router-link :to="{ name: 'responsible-trading' }" class="footer__link">
                      Responsible Trading
                    </router-link>
                  </template>
                </div>
                <div class="column small-12 medium-4">
                  <div :class="sectionClassModifiers('legal')" @click="toggleSection('legal')">
                    Legal
                  </div>
                  <div class="footer__section-divider"></div>
                  <template v-if="isSectionVisible('legal')">
                    <router-link :to="{ name: 'terms-and-conditions' }" class="footer__link">
                      Terms And Conditions
                    </router-link>
                    <router-link :to="{ name: 'privacy-policy' }" class="footer__link">
                      Privacy
                    </router-link>
                    <router-link :to="{ name: 'accessibility-statement' }" class="footer__link">
                      Accessibility Statement
                    </router-link>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <div class="footer__bottom">
      <div class="footer__bottom-content" v-if="isLayoutDesktop">
        <div class="footer__bottom-details" @click="onDetailsToggle">
          <div>Details</div>
          <div :class="footerBottomChevronModifiers"></div>
        </div>
        <div class="footer__links">
          <router-link :to="{ name: 'market-list' }" class="footer__links--item">
            Markets
          </router-link>
          <router-link :to="{ name: 'news-stories' }" class="footer__links--item">
            News
          </router-link>
          <router-link :to="{ name: 'HelpAndSupport' }" class="footer__links--item">
            Support
          </router-link>
          <router-link :to="{ name: 'platform-announcements' }" class="footer__links--item">
            Announcements
          </router-link>
        </div>
        <div class="footer__bottom-side-nav">
          <div class="footer__bottom-copy">
            The Truth Machine © {{ new Date().getFullYear() }} <brand-name></brand-name>. All rights
            reserved.
          </div>
          <div class="footer__logos">
            <div v-for="item in items" class="footer__logo-item">
              <a :href="item.href" :title="item.title" v-outer-link>
                <img :src="item.icon" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="footer__bottom-content" v-else>
        <div class="footer__links">
          <router-link :to="{ name: 'market-list' }" class="footer__links--item">
            Markets
          </router-link>
          <router-link :to="{ name: 'news-stories' }" class="footer__links--item">
            News
          </router-link>
          <router-link :to="{ name: 'HelpAndSupport' }" class="footer__links--item">
            Support
          </router-link>
          <router-link :to="{ name: 'platform-announcements' }" class="footer__links--item">
            Announcements
          </router-link>
        </div>
        <div class="footer__logos">
          <div v-for="item in items" class="footer__logo-item">
            <a :href="item.href" :title="item.title" v-outer-link>
              <img :src="item.icon" />
            </a>
          </div>
        </div>
        <div class="footer__bottom-copy">The Truth Machine</div>
        <div class="footer__bottom-copy">
          © {{ new Date().getFullYear() }} <brand-name></brand-name>. All rights reserved.
        </div>
      </div>
    </div>
  </footer>
</template>

<script src="./app-footer.js"></script>
<style src="./app-footer.scss" lang="scss"></style>
